module.exports = __webpack_public_path__ + "img/open-icon--dark.8d0d5955.svg";